import type { ReactNode } from "react";
import { cn } from "../lib/cn";

/**
 * RegionHead. Section title + optional sub-line above a content region.
 * Lifts the PlanScreen `RegionHead` helper into the kit so /plan,
 * /snapshot, /settings, and any future surface that wants a "named
 * section" can share the same chrome.
 *
 * The title uses Newsreader at a heading scale; sub is sans + gray.
 * Distinct from SectionHead in @healthos/ui/shell - that one is the
 * uppercase eyebrow rail above a column of cards; this is the
 * editorial heading inside a region's own content area.
 */
export interface RegionHeadProps {
  title: ReactNode;
  sub?: ReactNode;
  className?: string;
}

export function RegionHead({ title, sub, className }: RegionHeadProps) {
  return (
    <header className={cn("mb-4 flex flex-col gap-1", className)}>
      <h2 className="m-0 font-title text-[22px] font-medium leading-snug tracking-tight text-ink-primary">
        {title}
      </h2>
      {sub ? (
        <p className="m-0 max-w-[66ch] text-[13px] leading-relaxed text-ink-secondary">{sub}</p>
      ) : null}
    </header>
  );
}
